import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgModel } from '@angular/forms'; // Import NgModel, not NgForm
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-mat-remark-dialog',
  templateUrl: './mat-remark-dialog.component.html',
  styleUrls: ['./mat-remark-dialog.component.scss']
})
export class MatRemarkDialogComponent implements OnInit {
 remarkForm: FormGroup;

  constructor(
   public dialogRef: MatDialogRef<MatRemarkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) { 
    this.remarkForm = this.fb.group({
      remark: ['', Validators.required]
    });
  }

  ngOnInit(): void { }

   onSubmit() {
    if (this.remarkForm.valid) {
      this.dialogRef.close(this.remarkForm.value.remark.trim());
    } else {
      this.remarkForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}